const RECURRING = 'recurring';

export default {
  RECURRING,
};
